export default function Marquee() {
  const cls = "font-bebas text-3xl md:text-5xl text-black uppercase tracking-[0.05em]";
  const item = (
    <span className="inline-flex items-center gap-8 px-8">
      <span className={cls}>Sena Beauty</span>
      <span className={cls}>·</span>
      <span className={cls}>Porto</span>
      <span className={cls}>·</span>
      <span className={cls}>Brows</span>
      <span className={cls}>·</span>
      <span className={cls}>Lashes</span>
      <span className={cls}>·</span>
    </span>
  );

  return (
    <div
      data-testid="marquee"
      className="border-y border-black/10 py-5 overflow-hidden whitespace-nowrap"
    >
      <div className="marquee-track inline-flex">
        {item}
        {item}
        {item}
      </div>
    </div>
  );
}
